import React, { useMemo } from 'react';
import { ThemeProvider as EmotionThemeProvider } from 'emotion-theming';

import { getTheme } from '../theme';
import { useParent, useSession } from '../context';

type Props = {
  children: React.ReactNode;
};
export const ThemeProvider = React.memo((props: Props) => {
  const { isMobile } = useParent();
  const { botConfig } = useSession().site;
  const theme = useMemo(() => getTheme(isMobile, botConfig), [isMobile]);
  return <EmotionThemeProvider theme={theme} {...props} />;
});
